webpackJsonp([5],{

/***/ 1912:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1958)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1932),
  /* template */
  __webpack_require__(1982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-657d54bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'resultado-destinatarios',
  props: {
    total: {
      type: Number,
      default: function _default() {
        return 0;
      },
      required: true
    },
    destinatariosErroCep: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    }
  },
  data: function data() {
    return {
      isLoaded: false
    };
  },

  computed: {
    destinatariosCepInvalido: function destinatariosCepInvalido() {
      return this.destinatariosErroCep.length;
    },
    porcentagemEfetividade: function porcentagemEfetividade() {
      var valor = (this.destinatariosCepInvalido / this.total * 100).toFixed(2);
      return {
        valor: valor,
        class: parseInt(valor) === 0 ? 'text-success' : 'text-danger'
      };
    },
    semResultado: function semResultado() {
      return this.total === 0 && this.destinatariosCepInvalido === 0;
    }
  },
  filters: {
    formatarData: function formatarData(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY LTS');
    }
  },
  mounted: function mounted() {
    this.isLoaded = true;
  }
});

/***/ }),

/***/ 1947:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, ".resultado-estatísticas-geracao[data-v-657d54bc]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.resultado-estatísticas-geracao span[data-v-657d54bc]{font-weight:700}.resultado-success[data-v-657d54bc]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/leiloes/components/ResultadoDestinatarios.vue"],"names":[],"mappings":"AACA,iDACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,sDACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC","file":"ResultadoDestinatarios.vue","sourcesContent":["\n.resultado-estatísticas-geracao[data-v-657d54bc] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.resultado-estatísticas-geracao span[data-v-657d54bc] {\n  font-weight: bold;\n}\n.resultado-success[data-v-657d54bc] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1958:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("e3720c7a", content, true, {});

/***/ }),

/***/ 1982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Destinatários com CEP inválido")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.semResultado) ? _c('div', {
    staticClass: "resultado-estatísticas-geracao m-b-lg"
  }, [_c('div', [_vm._v("Total de Destinatários: "), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('div', [_vm._v("Destinatários com CEP inválido: "), _c('span', [_vm._v(_vm._s(_vm.destinatariosCepInvalido))])]), _vm._v(" "), _c('div', [_vm._v("Inválidos: "), _c('span', {
    class: _vm.porcentagemEfetividade.class
  }, [_vm._v(_vm._s(_vm.porcentagemEfetividade.valor) + "%")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.semResultado) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Leilão não foi gerado via preparação de leilão!")])]) : (parseInt(_vm.porcentagemEfetividade.valor) === 100) ? _c('div', {
    staticClass: "text-success resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Todos os lotes foram gerados com sucesso!")])]) : _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Endereço")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.destinatariosErroCep), function(item) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [_vm._v(_vm._s(item.cep))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.endereco))])])
  }), 0)])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.3371b172ee6013ffd461.js